"use client"

import { Input } from "@/shared/components/ui/input"
import { Search } from "lucide-react"
import { useRouter, useSearchParams } from "next/navigation"
import { useState } from "react"
import { useDebouncedCallback } from "use-debounce"

function PartnersSearch() {
    const router = useRouter()
    const searchParams = useSearchParams()
    const [searchValue, setSearchValue] = useState(
        searchParams.get("search") || ""
    )

    // Debounce search to avoid too many API calls
    const searchInputOnChangeHandler = useDebouncedCallback((value: string) => {
        const params = new URLSearchParams(searchParams.toString())

        if (value && value.trim().length > 0) {
            params.set("search", value)
        } else {
            params.delete("search")
        }

        router.push(`?${params.toString()}`)
    }, 750)

    return (
        <Input
            placeholder="Search partners"
            leftIcon={<Search className="text-muted-foreground text-sm w-4" />}
            className="h-10 rounded-md pl-9"
            value={searchValue}
            onChange={(e) => {
                const value = (e.target as HTMLInputElement).value
                setSearchValue(value)
                searchInputOnChangeHandler(value)
            }}
        />
    )
}

export default PartnersSearch

